<template>
  <v-row>
    <v-card color="#484848" max-width="434" class="not-found">
      <v-img
        src="/images/ps-horizontal.svg"
        height="90px"
        style="margin-top: 44px"
      ></v-img>
      <v-card-text class="not-found-header"> Oops! </v-card-text>
      <v-card-text class="not-found-text">
        Sorry, that page was not found.
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.not-found {
  margin: 10% auto auto;
}
.not-found-header {
  text-align: center;
  background: #818181;
  padding-bottom: 0px;
  color: white;
  font-size: 28px !important;
  font-weight: 800 !important;
  letter-spacing: normal !important;
  font-family: "Roboto", sans-serif !important;
}
.not-found-text {
  text-align: center;
  background: #818181;
  color: white;
  font-size: 28px !important;
  font-weight: 800 !important;
  letter-spacing: normal !important;
  font-family: "Roboto", sans-serif !important;
}
</style>
